import * as R from "ramda";
import * as React from "react";
import styled from "styled-components";
import { LocaleNames, PreferredLocale } from "../../../utils/locales";
import { NarrowSelect } from "./FormElements";

const StyledDiv = styled.div(
  ({ theme }) => `
  font-family: ${theme.primaryTheme.primaryFontFamily};
  font-size: ${theme.primaryTheme.primaryFontSize};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`
);
const StyledNarrowSelect = styled(NarrowSelect)(
  ({ theme }) => `
  margin: 0.5rem;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 0.3rem;
  border: none;
  font-size: ${theme.fontSizes.regular};
  border: 1px solid ${theme.colors.highlightLightGrey};
  outline: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  &: active {
    background-color: ${theme.colors.highlightLightGrey};
  }
`
);

export interface ILocaleSelectorProps {
  currentLocale: PreferredLocale;
  setLocale: (locale: PreferredLocale) => void;
}

export default class LocaleSelector extends React.Component<ILocaleSelectorProps> {
  private selector: React.RefObject<HTMLSelectElement>;

  constructor(props: ILocaleSelectorProps) {
    super(props);
    this.selector = React.createRef();
  }

  public changeLocale = () => {
    const { setLocale } = this.props;
    const { current: selector } = this.selector;

    if (R.isNil(selector)) {
      return;
    }

    setLocale(selector.value as PreferredLocale);
  };

  public render() {
    const { currentLocale } = this.props;
    return (
      <StyledDiv>
        This is a multi-locale course. You are currently editing:
        <StyledNarrowSelect
          name="locale-selector"
          onChange={this.changeLocale}
          ref={this.selector}
          value={currentLocale}
        >
          {R.toPairs(LocaleNames).map(([locale, name], i) => (
            <option key={i} value={locale}>
              {name}
            </option>
          ))}
        </StyledNarrowSelect>
      </StyledDiv>
    );
  }
}
